import React, { Component } from 'react';
import Formulario from './AgenteForm';
import LoadMask from "../../Utils/LoadMask/LoadMask";

class Agente extends Component{
    state = {
        crear: true,
    }

    componentDidMount = () => {
        const { match, leer, getModulo } = this.props;
        const id = match.params.id;
        if (id){
            this.setState({crear: false});
            leer(id);
        }
        let ruta = window.location.href;
        let modulo = ruta.split('/');
        getModulo(modulo[5],modulo[4])
    }
    
    render(){
        const { registroAgente, modificarAgente, loader, modulo  } = this.props;
        const { crear } = this.state;
        return(
            <LoadMask loading={loader} dark>
                <Formulario
                    registroAgente = {registroAgente}
                    crear = {crear}
                    modulo = {modulo}
                    modificarAgente = {modificarAgente}
                />
            </LoadMask>
        );
    }
}


export default Agente;
